import googleLibphonenumber from 'google-libphonenumber'

const phoneUtil = googleLibphonenumber.PhoneNumberUtil.getInstance()

const TYPE_OBJ = {
  '-1': 'UNKNOWN',
  0: 'FIXED_LINE',
  1: 'MOBILE',
  2: 'FIXED_LINE_OR_MOBILE',
  3: 'TOLL_FREE',
  4: 'PREMIUM_RATE',
  5: 'SHARED_COST',
  6: 'VOIP',
  7: 'PERSONAL_NUMBER',
  8: 'PAGER',
  9: 'UAN',
  10: 'VOICEMAIL',
} as const

/**
 * 獲取電話號碼的類型。
 * @param {string} phone - 電話號碼
 * @param {string} region - 地區代碼
 */
export function getPhoneNumberType(phone: string, region: string) {
  if (phone.length <= 1 || phone.length >= 19) {
    return 'UNKNOWN'
  } else {
    try {
      const number = phoneUtil.parseAndKeepRawInput(phone, region)
      const type = phoneUtil.getNumberType(number)
      return TYPE_OBJ[type]
    } catch {
      return null
    }
  }
}
